export default new Vue();


// WEBPACK FOOTER //
// ./src/components/Bus.js